import { render, staticRenderFns } from "./DisciplinaryPDF.vue?vue&type=template&id=49438786&scoped=true"
import script from "./DisciplinaryPDF.vue?vue&type=script&lang=js"
export * from "./DisciplinaryPDF.vue?vue&type=script&lang=js"
import style0 from "./DisciplinaryPDF.vue?vue&type=style&index=0&id=49438786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49438786",
  null
  
)

export default component.exports